import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { TableHeaderCellComponent } from '../table-header-cell/table-header-cell.component';
import { ColumnWidthDirective } from '../../directives/column-width.directive';
import { ColumnTypeCssClassPipe } from '../../pipes/column-type-css-class.pipe';
import { ToStringPipe } from '../../../text/pipes/to-string.pipe';
import { ColumnKeyCssClassPipe } from '../../pipes/column-key-css-class.pipe';
import { TableColumn } from '../../models/table-column';
import { TableHeaderItemActionComponent } from '../table-header-item-action/table-header-item-action.component';
import { valueOrDefault } from '@web/utils';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'tr[app-table-header-row]',
  imports: [
    CommonModule,
    TableHeaderCellComponent,
    ColumnWidthDirective,
    TableModule,
    ColumnTypeCssClassPipe,
    TableHeaderItemActionComponent,
    ToStringPipe,
    ColumnKeyCssClassPipe,
    TableHeaderCellComponent,
    ColumnWidthDirective,
    ColumnTypeCssClassPipe,
    ColumnKeyCssClassPipe,
    ToStringPipe,
  ],
  templateUrl: './table-header-row.component.html',
  styleUrls: ['./table-header-row.component.scss'],
})
export class TableHeaderRowComponent<Item, Filter> {
  public readonly columns = input.required<TableColumn<Item, Filter>[]>();
  public readonly reordering = input.required<boolean>();
  public readonly appendLabels = input.required<boolean>();

  public readonly sortClearEvent = output<void>();
  protected readonly valueOrDefault = valueOrDefault;
}
